import VueI18n from 'vue-i18n';
import { PhoenixRouteConfig } from '@front-app/router/Model';
import { Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { MemberSort } from '@front-app/modules/groupMember/hooks/useSortMemberRadio';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import { stringToEnum } from '@front-app/util/enum';

export const memberManagement: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				// TODO: Add group title here as well, somehow
				return i18n.t('admin-tabs.member-management') as string;
			},
			trappRoute(to: Route): string {
				return `/vgm.shtml?hcgd=${to.params.groupId}&role=members&sort=byLastName`;
			},
		},
		path: 'members',
		name: Routes.GROUP_ADMIN_MEMBER_MANAGEMENT,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				groupId: route.params.groupId,
				roleFilter: stringToEnum(route.query.role, UserRole, route.params.roleFilter as UserRole | UserRole.MEMBER),
				sortBy: stringToEnum(route.query.sortBy, MemberSort, MemberSort.ALPHABETICAL),
			};
		},
		// eslint-disable-next-line max-len
		component: () => import(/* webpackChunkName: "group-admin-members" */ '@front-app/views/home/group/admin/memberManagement/MemberManagement.vue'),
	},
];
